import type { RouteRecordRaw } from "vue-router"

export const OhMyBobsRoutes: RouteRecordRaw[] = [
  {
    path: "oh_my_bobs",
    children: [
      {
        path: "",
        redirect: ({ fullPath }) => {
          return `${fullPath}/experience`
        },
      },
      {
        path: "experience",
        name: "associate-menu.experience",
        component: () => import("./ExperienceTypeSelectionPage.vue"),
      },
      {
        name: "associate-menu.experience.at_home",
        path: "experience/at_home",
        component: () => import("./AtHomeOptionsPage.vue"),
      },
      {
        name: "associate-menu.experience.in_store",
        path: "experience/in_store",
        component: () => import("./InStoreOptionsPage.vue"),
      },
      {
        name: "associate-menu.experience.in_store.apply-options",
        path: "experience/in_store/:option",
        component: () => import("./InStoreApplyOptionsPage.vue"),
      },
      {
        path: "experience/in_store/:option/finish",
        component: () => import("./InStoreApplyFinish.vue"),
      },
    ],
  },
]
